export interface GstContext {
  enabled: boolean;      // is GST charged for the sale branch/gym
  sourceLabel: string;   // e.g. "HSR Layout" or "the gym"
}

// Human-readable reason for the GST% on a line item. The rate comes from the
// item itself (plan/service/product); the branch/registration only gates whether
// any GST applies at all.
export function explainGst(rate: number, ctx: GstContext): string {
  if (!ctx.enabled) {
    return rate > 0
      ? `${rate}% set on the item, but GST is off for ${ctx.sourceLabel} — no tax applied.`
      : `GST is off for ${ctx.sourceLabel} — no tax applied.`;
  }
  if (rate === 0) return `No tax on this item (0%).`;
  return `${rate}% GST on this item.`;
}

// YYYY-MM-DD string for the day after the given ISO date, or today when none.
export function nextDayISO(iso?: string | null): string {
  const base = iso ? new Date(iso) : new Date();
  if (iso) base.setDate(base.getDate() + 1);
  return base.toISOString().split('T')[0];
}
